/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Api_Routing_SingleInputs */

const en_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You call one endpoint per job with a single key, and AnyAPI returns one normalized schema whichever source serves it.`)
};

const zh_hans1_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每项任务调用一个接口，只需一个密钥，无论哪个数据源提供服务，AnyAPI 都返回同一套统一的 schema。`)
};

const pt_br2_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você chama um endpoint por tarefa com uma única chave, e a AnyAPI retorna um schema normalizado, seja qual for a fonte que atende.`)
};

const es_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llamas a un endpoint por tarea con una sola clave, y AnyAPI devuelve un único esquema normalizado sin importar qué fuente atienda la solicitud.`)
};

const fr_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous appelez un endpoint par tâche avec une seule clé, et AnyAPI renvoie un schéma normalisé unique quelle que soit la source qui répond.`)
};

const de_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du rufst einen Endpoint pro Aufgabe mit einem einzigen Schlüssel auf, und AnyAPI liefert ein normalisiertes Schema, egal welche Quelle antwortet.`)
};

const ru_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы вызываете один эндпоинт на задачу с одним ключом, а AnyAPI возвращает одну нормализованную схему, какой бы источник ни ответил.`)
};

const it_seo_api_routing_single = /** @type {(inputs: Seo_Api_Routing_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiami un endpoint per ogni lavoro con una sola chiave, e AnyAPI restituisce un unico schema normalizzato qualunque fonte la serva.`)
};

/**
* | output |
* | --- |
* | "You call one endpoint per job with a single key, and AnyAPI returns one normalized schema whichever source serves it." |
*
* @param {Seo_Api_Routing_SingleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_routing_single = /** @type {((inputs?: Seo_Api_Routing_SingleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_Routing_SingleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_routing_single(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_routing_single(inputs)
	if (locale === "es") return es_seo_api_routing_single(inputs)
	if (locale === "fr") return fr_seo_api_routing_single(inputs)
	if (locale === "de") return de_seo_api_routing_single(inputs)
	if (locale === "ru") return ru_seo_api_routing_single(inputs)
	if (locale === "it") return it_seo_api_routing_single(inputs)
	return en_seo_api_routing_single(inputs)
});